// extracted by mini-css-extract-plugin
export default {"root":"Search_root__b+1Fk","icon":"Search_icon__wEpbO","input":"Search_input__bS4gk","clearIcon":"Search_clearIcon__Gz8Xw"};